export default __webpack_public_path__ + "static/media/Rectangle 76.eb75af77.png";